<template>
  <div class="main-container all-devices-table-height">
    <!-- {{getUsers}} -->
    <div style="width: 100%;">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="getUsers"
        :isLoading="isLoadingVGT"
        :select-options="selectOption"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- {{props.row}} -->
          <span v-if="props.column.field == 'full_name'">{{
            props.row.name
          }}</span>
          <span v-if="props.column.field == 'cid'">{{
            props.row.CID ? props.row.CID : ""
          }}</span>
          <span v-if="props.column.field == 'devicetype'">{{
            props.row.deviceType.name
          }}</span>
          <span v-if="props.column.field == 'email'">{{
            props.row.user.email
          }}</span>
          <span v-if="props.column.field == 'phoneNumber'">{{
            props.row.user.phoneNumber
          }}</span>
          <span v-if="props.column.field == 'gender'">{{
            props.row.gender + "" === "0" ? "Female" : "Male"
          }}</span>
          <span v-else>{{ props.row[props.column.field] }}</span>
          <span v-if="props.column.field == 'actions'">
            <b-button-group>
              <b-button variant="primary" @click.stop="navTo(props.row.id)"
                >Details</b-button
              >
              <b-button
                variant="success"
                v-if="props.row.CID"
                @click.stop="toggleEditCanvas(props.row)"
                >Edit</b-button
              >
              <b-button
                variant="warning"
                v-if="props.row.CID"
                @click.stop="toggleUpdateCanvas(props.row)"
                >Complete</b-button
              >
            </b-button-group>
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>

      <!-- <div class="card-text" style="overflow-x: auto">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
        <b-table show-empty stacked="md" striped hover :items="getUsers" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered">
          <template slot="sn" slot-scope="row">{{
                row.item.originalIndex+1
                }}</template>
          <template slot="userId" slot-scope="row">{{ getUserById(row.item.userId).firstName +' '+getUserById(row.item.userId).lastName }}</template>
          <template slot="name" slot-scope="row">{{row.item.deviceType.name}}</template>
          <template slot="status" slot-scope="row">{{row.item.status}}</template>
          <template slot="actions" slot-scope="row">
            <b-button-group>
              <b-button variant="primary" @click.stop="navTo(row.item.id)">
                Details
              </b-button>
            </b-button-group>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card>
              <ul>
                <li v-for="(value, key) in row.item" :key="key" style="cursor: pointer;">{{ key }}: {{ value}}</li>
              </ul>
            </b-card>
          </template>
        </b-table>
        <b-col md="12" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" size="lg" />
        </b-col>
      </div>-->
    </div>

    <vk-offcanvas flipped overlay stuck :show.sync="openCompletionCanvas">
      <div style>
        <vk-offcanvas-close
          @click="openCompletionCanvas = false"
        ></vk-offcanvas-close>
        <h3>Update Completion Details</h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Purchase Price">
            <el-input
              style="width: 100%"
              id="purchase-price"
              v-model="regDataParams.purchase_price"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="Completion Date">
            <el-date-picker
              v-model="regDataParams.completion_date"
              type="date"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              :disabled="isLoading"
              type="prim​​ary"
              class="customer-btn"
              @click="onUpdateCompletion()"
              >{{ isLoading ? "Loading..." : "Update" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </vk-offcanvas>

    <vk-offcanvas flipped overlay stuck :show.sync="editOffCanvas">
      <div style>
        <vk-offcanvas-close @click="editOffCanvas = false"></vk-offcanvas-close>
        <h3>Edit</h3>
        <hr />
        <el-form
          class="form"
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item class="form-item" label="Name">
            <el-input
              style="width: 100%"
              id="customer-name"
              v-model="regDataParams.name"
              :min="1"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="User">
            <el-select
              style="width: 100%"
              v-model="regDataParams.userId"
              id="user-role"
              filterable
              remote
              :remote-method="fetchUser"
              placeholder="Assign Device"
            >
              <el-option
                v-for="user in users"
                :key="`${user.id}`"
                :label="`${user.firstName} ${user.lastName} - (${user.id})`"
                :value="`${user.id}`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="Device Type">
            <el-select
              style="width: 100%"
              v-model="regDataParams.deviceTypeId"
              id="device-type"
              filterable
              remote
              :remote-method="fetchSysTypes"
              placeholder="Choose Device Type"
            >
              <el-option
                v-for="(device, key) in systemTypeOptions"
                :key="key"
                :label="`${device.name}`"
                :value="device.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="Plan">
            <el-select
              style="width: 100%"
              v-model="regDataParams.plans"
              id="device-type"
              placeholder="Choose Device Plan"
            >
              <el-option
                v-for="(device, key) in plans"
                :key="key"
                :label="`${device} Device Plan`"
                :value="device"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="Installation Date">
            <el-date-picker
              v-model="period"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="prim​​ary"
              class="customer-btn"
              @click="onSubmit()"
              >{{ isLoading ? "Loading..." : "Update" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </vk-offcanvas>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  components: {
    //   Inventory
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      plans: ["OS", "LO", "ES"],
      deviceTypes: [],
      searchTerm: "",
      isLoadingVGT: true,
      editOffCanvas: false,
      openCompletionCanvas: false,
      isLoading: false,
      regDataParams: {
        name
      },
      completionDate: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [
        // {
        //   field: "id",
        //   label: "ID",
        //   sortable: "true"
        // },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true"
        },
        {
          field: "devicetype",
          label: "Device Type",
          sortable: "true"
        },
        {
          field: "cid",
          label: "Customer ID",
          sortable: "true"
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true"
        },
        // {
        //   field: "email",
        //   label: "E-mail",
        //   sortable: "true"
        // },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "createdAt",
          label: "Date Created",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      getUsers: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      users: [],
      currentUserId: 0,
      systemTypeOptions: [],
      period: [],
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    fetchUser(query) {
      if (query) {
        let ctx = this;
        const HTTP = this.$httpUtils.instance;
        const name = query.toLowerCase();

        setTimeout(() => {
          HTTP.get(
            `/users?filter={"where":{"or":[{ "firstName": {"regexp":"/${name}/i"}},{ "lastName": {"regexp":"/${name}/i"}}]}}`
          )
            .then(response => {
              ctx.users = response.data.filter(item => {
                if (
                  item.firstName.toLowerCase().includes(query.toLowerCase())
                ) {
                  return item;
                }
                if (item.lastName.toLowerCase().includes(query.toLowerCase())) {
                  return item;
                }
                if (item.email.toLowerCase().includes(query.toLowerCase())) {
                  return item;
                }
              });
            })
            .catch(error => {
              console.log("error", error);
            });
        }, 200);
      } else {
        // return ctx.users;
      }
    },
    fetchSysTypes(query) {
      if (query) {
        setTimeout(() => {
          const HTTP = this.$httpUtils.instance;
          const url = "/device_types";
          HTTP.get(url)
            .then(response => {
              const systemTypes = response.data;
              systemTypes.filter(x => {
                x.value = x.id;
                x.text = x.name;
              });

              this.systemTypeOptions = systemTypes.filter(item =>
                item.name.toLowerCase().includes(query.toLowerCase())
              );
              console.log("hello", this.systemTypeOptions);
            })
            .catch(error => {
              console.log("error", error);
            });
        });
      } else {
        return this.systemTypeOptions;
      }
    },
    onUpdateCompletion() {
      const HTTP = this.$httpUtils.instance;
      var container = this;
      let { id, completion_date, purchase_price } = container.regDataParams;

      if (!completion_date || !purchase_price) {
        this.showErrorMsg({
          message: "Please fill in all fields"
        });
        return;
      }
      let tempReg = {
        completion_date,
        purchase_price
      };
      this.toggleIsLoading();
      let url = `/installations/${id}`;

      HTTP.patch(url, tempReg)
        .then(response => {
          this.toggleIsLoading();
          container.regSuccess = true;
          this.showSuccessMsg({
            message: "Completion details Updated!"
          });
          this.init();
          this.openCompletionCanvas = false;

          this.regDataParams = {
            name: ""
          };
          this.$router.push({ path: "/devices/all_devices" });
        })
        .catch(error => {
          this.toggleIsLoading();
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = Object.keys(errorMsg);
            Object.values(errorMsg).map((x, index) => {
              errTemp[index] = keyHooks[index] + " " + x[0];
              // console.log(index);
            });
            // console.log("error", errTemp);
            errTemp = Object.values(errTemp).join("<br>");
            this.showErrorMsg({
              message: errTemp
            });
          } else {
            this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
    },
    onSubmit() {
      const HTTP = this.$httpUtils.instance;
      var container = this;
      let {
        name,
        id,
        deviceType,
        userId,
        deviceTypeId
      } = container.regDataParams;

      let from = this.period[0] !== undefined ? this.period[0] : false;
      let to = this.period[1] !== undefined ? this.period[1] : false;

      if (name == "") {
        this.showErrorMsg({
          message: "Name Is required"
        });

        return;
      }
      let tempReg = {
        name,
        userId,
        from,
        to,
        deviceTypeId
      };

      tempReg.userId = this.currentUserId;

      if (typeof tempReg.deviceTypeId === "string") {
        delete tempReg.deviceTypeId;
      }

      this.toggleIsLoading();
      let url = `/installations/${id}`;
      let deviceRequestUrl = `/device_requests/${deviceTypeId}`;

      HTTP.patch(deviceRequestUrl, { paymentModel: deviceType })
        .then(response => {
          this.editOffCanvas = false;
        })
        .catch(error => {});

      HTTP.patch(url, tempReg)
        .then(response => {
          this.toggleIsLoading();
          container.regSuccess = true;
          this.showSuccessMsg({
            message: "Installation Updated!"
          });
          this.init();
          this.editOffCanvas = false;

          this.regDataParams = {
            name: ""
          };
          this.$router.push({ path: "/devices/all_devices" });
        })
        .catch(error => {
          this.toggleIsLoading();
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = Object.keys(errorMsg);
            Object.values(errorMsg).map((x, index) => {
              errTemp[index] = keyHooks[index] + " " + x[0];
              // console.log(index);
            });
            // console.log("error", errTemp);
            errTemp = Object.values(errTemp).join("<br>");
            this.showErrorMsg({
              message: errTemp
            });
          } else {
            this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    toggleEditCanvas(data) {
      this.currentUserId = data.user.id;
      this.regDataParams = {
        ...data,
        userId: `${data.user.firstName} ${data.user.lastName} - (${data.user.id})`,
        deviceTypeId: data.deviceType.name,
        plans: data.plan || this.plans[0]
      };
      this.editOffCanvas = !this.editOffCanvas;
      this.period = [data.from, data.to];
      // console.log({ data });
    },
    toggleUpdateCanvas(data) {
      this.regDataParams = data;
      this.openCompletionCanvas = !this.openCompletionCanvas;
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "maintenance"
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let realm = this.getUserSession.realm;

      let url = `/installations?filter={"where":{"and": [{"userId":${userId}}, {"or":[{ "status": "commissioned"},{ "status": "completed"}]}]},"include":["deviceType","user","operationsEngineer"]}`;
      if (this.$can("manage", "customer"))
        url = `/installations?filter={"where":{"realm":{"$regex" :"^${realm}"}},"include":["deviceType","user","operationsEngineer"]}`;
      if (this.$can("read", "all"))
        url = `/installations?filter={"include":["deviceType","user","operationsEngineer"]}`;

      httpUtils.instance
        .get(url)
        .then(response => {
          this.getUsers = response.data;
          this.isLoadingVGT = false;
        })
        .catch(error => {
          console.log(error);
          this.errors = "Error occured at our end!";
          this.getUsers = "";
        });
    }
  },
  async mounted() {
    this.init();

    // console.log(this.getDummy)
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.all-devices-table-height {
  height: calc(100vh - 280px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/List.vue